"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmeticsData = void 0;
const emotes_1 = require("./data/emotes");
const heads_1 = require("./data/heads");
exports.CosmeticsData = {
    emotes: emotes_1.emotes,
    heads: heads_1.heads,
};
